module.exports = __webpack_public_path__ + "static/media/IconPlantilla.e2ffe889.svg";